export const useStyles = () => ({
	affiliateBannerBg: {
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat',
		backgroundColor: '#000000',
		borderBottom: 'solid 1px #E40784',
		padding: '10px',
		boxShadow: '0 3px 20px rgba(0,0,0,0.5)'
	},
	'@media (max-width: 800px)': {
		affiliateBannerContainer: {
			flexDirection: 'column'
		},
	},
	affiliateBannerContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexWrap: 'wrap',
		maxWidth: 1150,
		padding: 10,
		position: 'relative',
		zIndex: 10,
	},
	affiliateBannerText: {
		fontSize: 36,
		fontWeight: '800',
		lineHeight: '48px',
		color: '#ffffff',
		marginRight: '10px'
	},
	affiliateBannerLogo: {
		position: 'relative',
		top: '-2px'
	}
});